import React, { useEffect } from 'react';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  ButtonSize,
  FormTemplate,
  IconType,
  OptionSelectionButton,
  TextInput, useFilterContext
} from 'ui-builder';
import {
  CreateGlobalDetailsFieldRequest,
  ProjectDetailsField, ProjectDetailsFilter,
  ProjectType,
  useProjectDetailsFieldsAdminService
} from 'nekst-api';
import ProjectDetailsFieldTypeDropdown
  from '../../../projectdetails/CreateUpdate/ProjectDetailsFieldTypeDropdown';
import { usePopupFormManager } from 'features/nekst-widgets';
import { ProjectTypeMultiSelectDropdown, useProjectTypeHelper } from 'features/tasks-forms';
import ParentFieldDropdown from '../../../projectdetails/Sets/List/ParentFieldDropdown';
import { createPortal } from 'react-dom';
import CreatePlanFromFieldsForm from './CreatePlanFromFieldsForm';

export function CreateDetailFieldForm(props: {
  setupAreaId: number,
  setupAreaVersion: string,
  projectTypes?: ProjectType[],
  afterSubmitFunc?: AfterSubmitFunc,
}) {
  const detailBoxAdminService = useProjectDetailsFieldsAdminService();

  const projectTypeHelper = useProjectTypeHelper();

  return (
    <FormTemplate<CreateGlobalDetailsFieldRequest & {
      projectType: ProjectType
    }, ProjectDetailsField>
      title="Create Detail Box"
      submitFormFunc={async (request) => {
        return await detailBoxAdminService.createField(
          props.setupAreaId,
          props.setupAreaVersion,
          request
        );
      }}
      initialData={{
        order: 0,
        projectTypes: props.projectTypes || projectTypeHelper.getTypes()
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        fieldType: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        projectTypes: {
          type: 'array',
          constraints: {
            required: true
          }
        }
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" label="Name" />
      <ProjectDetailsFieldTypeDropdown source="fieldType" label="Box Type" />
      <ProjectTypeMultiSelectDropdown source="projectTypes" label="Transaction Types" />
      <ParentFieldDropdown />
    </FormTemplate>
  );
}

export function CreateDetailFieldButtonPortal() {
  return (
    <span id="create-detail-field-button-portal" />
  );
}

export function CreateDetailFieldButton(
  props: {
    areaId: number,
    version: string,
  }
) {
  const popupFormManager = usePopupFormManager();

  const element = document.getElementById('create-detail-field-button-portal');

  if (element) {
    return createPortal(
      (
        <Button
          text="Add Detail Box"
          iconType={IconType.PLUS}
          color={ButtonColor.BLUE}
          onClick={() => popupFormManager.openForm((
            <CreateDetailFieldForm
              setupAreaId={props.areaId}
              setupAreaVersion={props.version}
            />
          ))}
          isFilled
        />
      ),
      element
    );
  } else {
    return null;
  }
}

export function DetailFieldsOptionsButton(
  props: {
    areaId: number,
    version: string,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {

  const filterContext = useFilterContext<ProjectDetailsFilter>();

  const projectType = filterContext.filterValue?.projectType;

  const popupFormManager = usePopupFormManager();

  const element = document.getElementById('create-detail-field-button-portal');

  const [init,setInit] = React.useState(false);

  useEffect(() => {
    if(!init) {
      setInit(true);
    }
  }, [element]);

  if (element && init) {
    return createPortal(
      <OptionSelectionButton
        text="Actions"
        options={[
          {
            value: 'create_field',
            label: 'Create Detail Box',
            onSelected: () => {
              popupFormManager.openForm((
                <CreateDetailFieldForm
                  setupAreaId={props.areaId}
                  setupAreaVersion={props.version}
                  projectTypes={projectType ? [projectType] : undefined}
                />
              ));
            }
          },
          {
            value: 'create_plan',
            label: 'Create Plan',
            onSelected: () => {
              popupFormManager.openForm((
                <CreatePlanFromFieldsForm
                  setupAreaId={props.areaId}
                  setupAreaVersion={props.version}
                  projectType={projectType}
                />
              ));
            }
          }
        ]}
        size={ButtonSize.MEDIUM}
      />,
      element
    );
  } else {
    return null;
  }

}
